import { z, type ZodTypeAny } from 'zod'
import { FieldState } from '@/shared/constants'
import { id } from '@/helpers/validation'

export function schemaForFieldWithState<TType extends ZodTypeAny>(value: TType) {
  return z.object({
    value,
    state: z.nativeEnum(FieldState).nullable(),
    reason: z.string().nullable(),
  })
}

export const ownerSchema = z.object({
  id: z.number().int().gt(0),
  name: z.string()
})
